import React from 'react'

export const RightsInfo = (props) =>{
//    console.log(props)
//    let cpt = props
    return (
        <div className="yahav-modal" style={{marginBottom: '100px'}}>
            <h2>כלים</h2>
            <div className="tools-tab">
                <div className="rights-tools">
                    <h3>כלי המערכת</h3>
                    <button type="button"  className="btn btn-primary pull-right" 
                            onClick={()=> window.open(props.getAmadotShortcodeLink(props.cptId, props.family_members), "_blank")}>
                            השוואת שאלוני עמדות
                    </button>
                </div>
                <div className="rights-calc">
                    <h3>מחשבוני שכר וזכאות</h3>
                    <ul>
                        {rcalc_item("http://www.goleango.com/salary-calculator.php", "מחשבון שכר" )}
                        {rcalc_item("https://www.btl.gov.il/Simulators/Pages/default.aspx", "מחשבוני זכויות בט''ל - ראשי" )}
                        {rcalc_item("http://www.btl.gov.il/Simulators/Pages/HishuvKitzvaList.aspx", "חישוב סכום קצבה" )}
                        {rcalc_item("http://www.btl.gov.il/Simulators/Pages/IncomeSupportCalc.aspx", "חישוב סכום קצבת הבטחת הכנסה" )}
                        {rcalc_item("http://www.btl.gov.il/Simulators/Pages/BdikatZacautList.aspx", "בדיקת זכאות לקצבאות" )}
                    </ul>
                </div>        
                <div className="usefull-links">
                    <h3>מידע שימושי</h3>
                    <ul>
                    { rcalc_item("https://www.btl.gov.il/Publications/oni_report/Documents/oni2017.pdf", 'דוח שנתי - ממדי העוני 2017 ביטוח לאומי')}
                    { rcalc_item("https://www.btl.gov.il/AllRights/Pages/default.aspx", "מיצוי זכויות ביטוח לאומי")}
                    { rcalc_item("https://www.btl.gov.il/benefits/Pages/default.aspx", "קצבאות והטבות")} 
                        { rcalc_item("https://www.molsa.gov.il/Rights/Pages/Rights.aspx", "מיצוי זכויות חברתיות - משרד העבודה והרווחה")}
                        { rcalc_item("https://www.kolzchut.org.il/he/%D7%A2%D7%9E%D7%95%D7%93_%D7%A8%D7%90%D7%A9%D7%99", "אתר כל זכות")}
                        
                        { rcalc_item("https://www.misim.gov.il/gmMhsBakasha/frmBakasha.aspx", "מענק עבודה – הגשת תביעה מקוונת")}
                        
                        { rcalc_item("https://www.misim.gov.il/shmaanakavoda/frmFirst.aspx", "סימולטור לחישוב מענק עבודה")}
                        { rcalc_item("https://b2b.btl.gov.il/BTL.ILG.Payments/DocumentsForm.aspx", "שליחת מסמכים באינטרנט ישירות לפקיד ביטוח לאומי")}
                    </ul>
                    </div>               
                <div className="rights-calc">
                    <h3>טפסים שימושיים</h3>
                    <ul>
                        {rcalc_item("https://www.btl.gov.il/%D7%98%D7%A4%D7%A1%D7%99%D7%9D%20%D7%95%D7%90%D7%99%D7%A9%D7%95%D7%A8%D7%99%D7%9D/Documents/T1500.pdf", 
                                "תביעה לדמי אבטלה - 1500" )}
                        {rcalc_item("https://www.btl.gov.il/%D7%98%D7%A4%D7%A1%D7%99%D7%9D%20%D7%95%D7%90%D7%99%D7%A9%D7%95%D7%A8%D7%99%D7%9D/Documents/T1500.pdf", 
                                "פרויקט מחשב לכל ילד - בקשת הורי המועמד/ת להשתתף בפרויקט" )}
                        {check_pc4any(props)}
                    </ul>
                </div>
            </div>
            <p style={{marginTop:'30px'}}>מעוניינים בקישור נוסף? שילחו אלי במייל עכשיו תוך ציון: 1. קטגוריה, 2. כותרת ו- 3.קישור
            <a style={{color:'blue', marginRight:'7px', fontWeight:'600', textDecoration: 'underline'}} 
                rel="noopener noreferrer" href="mailto:mulli@site2goal.co.il">אל מולי במייל</a>
                <br />
                ניתן לפנות אלי בכל הצעה, בעיה או שאלה לאותו המייל
            </p>
        </div>
    )
}

const rcalc_item = (link, label) =>
        <li><a href={link} rel="noopener noreferrer" target="_blank">{label}</a></li>
/*
const usefull_link_item = (link, label) =>
        <button type="button"  className="btn btn-primary pull-right" 
                onClick={()=> window.open({link}, "_blank")}>
                {label}
        </button>
*/
// test if qualifies for the project

const check_pc4any= (cpt) => {
// test phone number -must have one
// no internet connection
// no computer at home
// test for kids in right age - say 9 to 14
// q31 - מחשב  q32 - חיבור לאינטרנט
    const c = cpt
    if (is_empty(c['program_info']['man_cellphone']) && is_empty(c['program_info']['woman_cellphone']) && is_empty(c['program_info']['family_phone']))
        return (<span className="right-test right-test-missing">לא ידוע - חסר מידע על טלפון בבית או הורים</span>)
   
    // Cannot have either pc or internet connection
    if (is_empty(c['family_products_services']['q31']) && is_empty(c['family_products_services']['q32']))
        return (<span className="right-test right-test-missing">לא ידוע - חסר מידע על מחשב ו/או חיבור לאינטרנט</span>)

    if (c['family_products_services']['q31'] === 'כן' || c['family_products_services']['q32'] === 'כן')
        return (<span className="right-test right-test-no">אין זכאות - יש מחשב או חיבור לאינטרנט</span>)

    let found = false
    c['family_kids'].map(kid => found = (kid['kid_misgeret'] === 'בית ספר יסודי' ) || found)
    if (!found)
        return (<span className="right-test right-test-no">אין זכאות - אין ילד בבית ספר יסודי</span>)

    return (<span className="right-test right-test-yes">יש זכאות לפי הנתונים במערכת</span>)

}

const is_empty = (field) => (field === undefined || field === "" || field === false)